import { type ReactNode, useEffect, useRef } from "react";
import { type LineSegments, Vector3 } from "three";

interface LineComponentProps {
	start: [x: number, y: number, z: number];
	end: [x: number, y: number, z: number];
	children?: ReactNode;
}

const startPoint = new Vector3(0, 0, 0);
const endPoint = new Vector3(0, 0, 0);

export default function LineComponent(props: LineComponentProps) {
	const { start, end, children, ...remainingProps } = props;
	const ref = useRef<LineSegments>(null);

	useEffect(() => {
		ref.current?.geometry.setFromPoints([startPoint.set(...start), endPoint.set(...end)]);
	}, [end, start]);

	return (
		<lineSegments ref={ref} {...remainingProps}>
			<bufferGeometry />
			<lineBasicMaterial color="#979797" linewidth={1} fog={false} />
			{children}
		</lineSegments>
	);
}
